// How to use in component:

// import { Toast, ToastColor } from '../utils/toastNotification'
// new Toast({
//   message: 'Enviado com sucesso!',
//   color: ToastColor.Success,
//   time: 5000
// });

// ------------------------------------
export class Toast {
  constructor({ message, color, time }) {
    this.message = message;
    this.color = color;
    this.time = time;
    this.element = null;

    const element = document.createElement('div');
    element.className = 'toast-notification';
    this.element = element;
    const countElements = document.getElementsByClassName('toast-notification');

    element.style.opacity = '0.8';
    element.style.marginBottom = countElements.length * 55 + 'px';
    element.style.backgroundColor = this.color;
    element.style.width = 'fit-content';
    element.style.height = '40px';
    element.style.padding = '10px';
    element.style.margin = '20px';
    element.style.borderRadius = '10px 15px';
    element.style.color = 'white';
    element.style.position = 'fixed';
    element.style.top = '10%';
    element.style.left = '80%';
    element.style.justifyContent = 'center';
    element.style.alignItems = 'center';
    element.style.zIndex = '9999';
    element.style.textAlign = 'center';

    const messageToast = document.createElement('div');
    messageToast.className = 'message-container';
    messageToast.textContent = this.message;

    element.appendChild(messageToast);
    document.body.appendChild(element);

    setTimeout(function () {
      element.remove();
    }, this.time);
  }
}

export const ToastColor = {
  Danger: '#eb3b5a',
  Warning: '#fdcb6e',
  Success: '#00bd97',
};
